// One shared store, no polling and no telemetry payloads/identifiers.
let state = {online: typeof navigator === 'undefined' || navigator.onLine !== false, live: 'idle', snapshot: 'ready'};
const listeners = new Set();
export const getConnection = () => state;
export const subscribeConnection = listener => {listeners.add(listener); return () => listeners.delete(listener);};
export function setConnection(patch) {
  if (Object.keys(patch).every(key => state[key] === patch[key])) return;
  state = {...state, ...patch};
  listeners.forEach(listener => listener());
}
if (typeof window !== 'undefined') {
  window.addEventListener('offline', () => setConnection({online: false}));
  window.addEventListener('online', () => setConnection({online: true}));
}

export function positionFreshness(utime, now = Date.now()) {
  const seconds = Number(utime);
  if (!Number.isFinite(seconds) || seconds <= 0 || seconds * 1000 > now + 60000) {
    return {label: 'Čas polohy není dostupný', stale: true};
  }
  const minutes = Math.floor(Math.max(0, now / 1000 - seconds) / 60);
  const age = minutes < 1 ? 'před méně než minutou' : minutes < 60 ? `před ${minutes} min` :
    minutes < 1440 ? `před ${Math.floor(minutes / 60)} h` : `před ${Math.floor(minutes / 1440)} dny`;
  return {label: `Poslední poloha ${age}`, stale: minutes >= 15, date: new Date(seconds * 1000).toLocaleString('cs-CZ')};
}
